import React, { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../loginSlice";
import "./login.css";
import { setBackButtonUrl } from "../uiSlice";
import Swal from "sweetalert2";
import { PirateButton, useDisableInspect, useSceneBackground } from "../escapeShared";
import bgImg from "../img/bg1.jpg";
import bgImgMobile from "../img/mob_bg1.jpg";
import logoImg from "../../img/logo.png";

/** Title screen (reference UI #1, old/index.php). */
function Login() {
  const dispatch = useDispatch();
  const { status, user, error } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  useDisableInspect();
  useSceneBackground(bgImg, bgImgMobile);

  // old/index.php's BEGIN PLAY led into old/rules1.php.
  const handleBeginPlay = useCallback(
    (e) => {
      e.preventDefault();
      if (!user) return;
      navigate("/rules", { replace: true });
    },
    [user, navigate]
  );

  useEffect(() => {
    dispatch(loginUser());
  }, [dispatch]);

  useEffect(() => {
    if (status === "succeeded" && user?.backButtonRedirect) {
      dispatch(setBackButtonUrl(user.backButtonRedirect));
    }
  }, [status, user, dispatch]);

  useEffect(() => {
    if (status !== "failed") return;
    const msg = error ? String(error) : "Session expired";
    const redirect = user && user.backButtonRedirect ? user.backButtonRedirect : "/";
    Swal.fire("Session Expired!", msg, "error").then(() => {
      window.location.href = redirect;
    });
  }, [status, error, user]);

  // old/index.php blocked a replay once stat_escape.stage5 was set; here that
  // is the login payload's gameover (DB stages.gameover).
  useEffect(() => {
    if (status !== "succeeded" || !user) return;
    if (Number(user.gameover ?? 0) > 0) {
      const redirect = user.backButtonRedirect || "/";
      Swal.fire("", "You have played this game already", "error").then(() => {
        window.location.href = redirect;
      });
    }
  }, [status, user]);

  return (
    <div className="login-page">
      <h1 className="login-title">
        <img src={logoImg} className="login-logo" alt="Room to Escape" />
      </h1>

      {status === "succeeded" && user ? (
        <PirateButton className="login-begin" onClick={handleBeginPlay}>
          Begin Play
        </PirateButton>
      ) : null}
    </div>
  );
}

export default Login;
